<template>
    <Nuxt-Img v-if="image?.mainImage" :src="image.mainImage.url" :alt="alt" />
</template>

<script setup>

defineProps({
    image: {
        type: Object,
        default: () => undefined,
        required: false,
    },
    alt: {
        type: String,
        default: 'image has no alt',
        required: false,
    },
});

</script>
